// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExchangeRate_inactive__Q6Y5X {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-weight: 700;
  font-size: 1rem;
  width: 8rem;
  height: 3rem;
  background: #FFE8E8;
  color: #E12F2F;
  border: 0.5px solid #E12F2F;
  border-radius: 5px;
}

.ExchangeRate_active__AHSKr {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-weight: 700;
  font-size: 1rem;
  width: 8rem;
  height: 3rem;
  background: #E4FFEC;
  color: #569755;
  border: 0.5px solid #569755;
  border-radius: 5px;
}

.ExchangeRate_modal__JtS0Q {
  width: 40rem;
}
.ExchangeRate_modal_title__Wduyh {
  width: 100%;
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 3rem;
  color: #4A4A68;
  margin: 5rem 0 4rem 0;
}
.ExchangeRate_modal_section__jKuwh {
  display: flex;
  flex-direction: column;
  width: 38rem;
  gap: 1rem;
  margin-bottom: 2rem;
}
.ExchangeRate_modal_section__key__5gDwu {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #1F68D6;
}
.ExchangeRate_modal_section__value__Ojw6Z {
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #4A4A68;
}

.ExchangeRate_metrics__z6Prx {
  box-sizing: border-box;
  width: 30rem;
  display: grid;
  grid-template-columns: 1fr;
}
.ExchangeRate_metrics__numberOfBusinesses__KTKKv {
  background-color: var(--color-green);
  color: var(--color-white);
  width: 30rem;
}

.ExchangeRate_searchInMiddle__Vts5I {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5rem;
  margin-bottom: 3rem;
}
@media only screen and (max-width: 37.5em) {
  .ExchangeRate_searchInMiddle__Vts5I {
    flex-direction: column;
  }
  .ExchangeRate_searchInMiddle__Vts5I > :not(:last-child) {
    margin-bottom: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ExchangeRate/ExchangeRate.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;AADJ;;AAIA;EAEI,YAAA;AAFJ;AAII;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;AAHR;AAKQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAMQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAJZ;;AASA;EACI,sBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AANJ;AASI;EACI,oCAAA;EACA,yBAAA;EACA,YAAA;AAPR;;AAaA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;AAYI;EAPJ;IAQQ,sBAAA;EATN;EAWM;IACI,mBAAA;EATV;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.inactive {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    font-weight: 700;\n    font-size: 1rem;    \n    width: 8rem;\n    height: 3rem;\n    background: #FFE8E8;\n    color: #E12F2F;\n    border: 0.5px solid #E12F2F;\n    border-radius: 5px;\n}\n\n.active {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    font-weight: 700;\n    font-size: 1rem;    \n    width: 8rem;\n    height: 3rem;\n    background: #E4FFEC;\n    color: #569755;\n    border: 0.5px solid #569755;\n    border-radius: 5px;\n}\n\n.modal {\n\n    width: 40rem;\n\n    &_title {\n        width: 100%;\n        font-weight: 700;\n        font-size: 2.4rem;\n        line-height: 3rem;       \n        color: #4A4A68;\n        margin: 5rem 0 4rem 0;       \n    }\n\n    &_section {\n        display: flex;\n        flex-direction: column;\n        width: 38rem;\n        gap: 1rem;\n        margin-bottom: 2rem;\n\n        &__key {\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 17px;            \n            color: #1F68D6;\n        }\n\n        &__value {\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 22px;\n            color: #4A4A68;\n        }\n    }\n}\n\n.metrics {\n    box-sizing: border-box;\n    width: 30rem;\n    display: grid;\n    grid-template-columns: 1fr;   \n   \n\n    &__numberOfBusinesses {\n        background-color: var(--color-green);\n        color: var(--color-white);\n        width: 30rem;\n        \n    }\n\n}\n\n.searchInMiddle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 5rem;\n    margin-bottom: 3rem;\n\n    @media only screen and (max-width: $bp-600) {\n        flex-direction: column;\n\n        & > :not(:last-child) {\n            margin-bottom: 2rem;\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inactive": `ExchangeRate_inactive__Q6Y5X`,
	"active": `ExchangeRate_active__AHSKr`,
	"modal": `ExchangeRate_modal__JtS0Q`,
	"modal_title": `ExchangeRate_modal_title__Wduyh`,
	"modal_section": `ExchangeRate_modal_section__jKuwh`,
	"modal_section__key": `ExchangeRate_modal_section__key__5gDwu`,
	"modal_section__value": `ExchangeRate_modal_section__value__Ojw6Z`,
	"metrics": `ExchangeRate_metrics__z6Prx`,
	"metrics__numberOfBusinesses": `ExchangeRate_metrics__numberOfBusinesses__KTKKv`,
	"searchInMiddle": `ExchangeRate_searchInMiddle__Vts5I`
};
export default ___CSS_LOADER_EXPORT___;
